module.exports = __webpack_public_path__ + "img/7d24335.png";